import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { AuthLayout, ErrorBox } from 'src/core/components';
export var Error404 = function () {
    return (_jsx(AuthLayout, { children: _jsx(ErrorBox, { title: "Page not found!", summary: "The page you're trying to access was not found. That's all we know.", my: 50 }, void 0) }, void 0));
};
